import { useState, useRef, useEffect } from "react";

export const useMouseMoveOver = (): {
  elementRef: React.RefObject<HTMLElement | null>;
  isMouseInsideElement: boolean;
} => {
  const elementRef = useRef<HTMLElement | null>(null);
  const [isMouseInsideElement, setIsMouseInsideElement] = useState(false);

  useEffect(() => {
    interface MouseMoveEvent extends MouseEvent {
      clientX: number;
      clientY: number;
    }

    const handleMouseMove = (e: MouseMoveEvent) => {
      const element = elementRef.current;
      if (element) {
        const rect = element.getBoundingClientRect();
        const isWithinBounds = e.clientX >= rect.left && e.clientX <= rect.right && e.clientY >= rect.top && e.clientY <= rect.bottom;

        setIsMouseInsideElement(isWithinBounds);
      }
    };

    globalThis.addEventListener("mousemove", handleMouseMove);

    return () => {
      globalThis.removeEventListener("mousemove", handleMouseMove);
    };
  }, []);

  return { elementRef, isMouseInsideElement };
};
